export default "__VITE_ASSET__DwhYg6bu__";